import React from 'react';
import { CheckCircle2, Users, School, Award } from 'lucide-react';
export const WhyNisaWorks = () => {
  const stats = [{
    icon: <Users className="w-6 h-6" data-id="element-471" data-mp="3cybe9celqvj7" />,
    value: '94%',
    label: 'of coaches report reduced administrative workload',
    gradient: 'from-primary-500 to-primary-600'
  }, {
    icon: <School className="w-6 h-6" data-id="element-472" data-mp="34587fmygpgxj" />,
    value: '2.5x',
    label: 'more time spent directly supporting teachers',
    gradient: 'from-purple-600 to-pink-600'
  }, {
    icon: <Award className="w-6 h-6" data-id="element-473" data-mp="3vul1ap7hewfc" />,
    value: '87%',
    label: 'of teachers report more personalized support',
    gradient: 'from-pink-600 to-orange-600'
  }];
  return <section id="why-nisa-works" className="w-full bg-white py-section-mobile md:py-section-desktop relative overflow-hidden" data-id="element-474" data-mp="3muepr8vcg6it">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-475" data-mp="26fd8xcssx05x">
        <div className="grid md:grid-cols-12 gap-8 lg:gap-20 items-center" data-id="element-476" data-mp="2bg166g7mid8l">
          <div className="md:col-span-8 lg:col-span-7" data-id="element-477" data-mp="3a5umh2fo0rvn">
            <h2 className="text-h2-mobile md:text-h2-desktop font-serif font-normal text-cyan-800 mb-4 leading-tight" data-id="element-478" data-mp="3a6e6coovlqcb">
              Built on research.
              <br data-id="element-479" data-mp="3k4tq26lkpxbs" />
              Designed with coaches.
            </h2>
            <div className="space-y-8 md:space-y-10" data-id="element-480" data-mp="3f579poag80yr">
              <p className="text-xl text-cyan-900" data-id="element-481" data-mp="3f4fmb0r099jk">
                Nisa supports meaningful relationships and evidence-based
                instruction.
              </p>
              <div className="space-y-6 text-gray-600" data-id="element-482" data-mp="3p46lvgufaeqi">
                <p data-id="element-483" data-mp="3p1kebh7j7z8a">
                  We believe coaching should feel human. Nisa is designed to
                  model instructional best practices. Instead of simply
                  automating tasks, we provide research-aligned scaffolds
                  grounded in the real world of coaching.
                </p>
                <p data-id="element-484" data-mp="boqq6n0pdcy0">
                  The system is powered by a deep partnership with{' '}
                  <a href="https://teachinglab.org/" target="_blank" rel="noopener noreferrer" className="text-primary-500 hover:text-primary-600 underline underline-offset-2 transition-colors duration-200" data-id="element-485" data-mp="iroz7tuy75zx">
                    Teaching Lab's team
                  </a>{' '}
                  of instructional experts, drawing on a proven coaching theory
                  of action used in districts across the country.
                </p>
              </div>
            </div>
          </div>
          <div className="md:col-span-4 lg:col-span-5 space-y-8 lg:flex lg:flex-col lg:justify-end" data-id="element-486" data-mp="16j3zzi72tf92">
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 md:p-8 shadow-lg border border-gray-100" data-id="element-487" data-mp="1gffgylhm2t9u">
              <div className="space-y-6" data-id="element-488" data-mp="3d890pcct7tel">
                {['Research-backed coaching frameworks', 'Evidence-based instructional strategies', 'Personalized teacher support pathways'].map((point, index) => <div key={index} className="flex items-center gap-4 group" data-id="element-489" data-mp="35wukm0vhe3h6" data-mpi={index}>
                    <div className="flex-shrink-0 transform transition-transform duration-300 group-hover:scale-110" data-id="element-490" data-mp="35uq6kq3vbo36">
                      <CheckCircle2 className="w-7 h-7 text-primary-600" data-id="element-491" data-mp="2vyn4fk90npg8" />
                    </div>
                    <span className="text-lg text-gray-800 font-medium" data-id="element-492" data-mp="3tlvjoxifc29s">
                      {point}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};